<template>
  <CheckFormBox :title="$t('hzmbChange.title.owner_data')">
    <el-row :gutter="48" type="flex">
      <el-col :xs="24" :sm="12">
        <div class="form_label">{{ $t("hzmbChange.label.spNo") }}：</div>
        <div class="form_value">{{ caseNo }}</div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{
            isGHCompany
              ? $t("hzmbChange.label.registrationNo")
              : $t("hzmbChange.label.quotaRegistrationNo")
          }}：
        </div>
        <div class="form_value">{{ data.quotaRegistrationNo }}</div>
      </el-col>
      <el-col :xs="24" :sm="12" v-if="isPerson">
        <div class="form_label">
          {{ $t("hzmbChange.label.personal_idType") }}：
        </div>
        <div class="form_value">
          {{
            data.applicantIdentType && idType.length > 0
              ? idType.find((item) => item.codeKey == data.applicantIdentType)[
                  $t("message.codeName")
                ]
              : ""
          }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" v-if="isPerson">
        <div class="form_label">
          {{ $t("hzmbChange.label.personIdentityNo") }}：
        </div>
        <div class="form_value">{{ data.applicantIdentNo }}</div>
      </el-col>
      <!-- PERSON -->
      <template v-if="isPerson">
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.personNameCn") }}：
          </div>
          <div class="form_value">{{ data.applicantCname }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.personNameEn") }}：
          </div>
          <div class="form_value">{{ data.applicantEname }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.personBirthday") }}：
          </div>
          <div class="form_value">
            {{ data.birthday | formatDT("dd/MM/yyyy") }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12"></el-col>
      </template>
      <!-- COMPANY -->
      <template v-if="isCompany">
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.macau_company_type") }}：
          </div>
          <div class="form_value">
            {{
              data.companyIdentityType && companyType.length > 0
                ? $t(
                    companyType.find(
                      (item) => item.code == data.companyIdentityType
                    ).label
                  )
                : ""
            }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.companyBrNo") }}：
          </div>
          <div class="form_value">{{ data.companyBrNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.companyNameCn") }}：
          </div>
          <div class="form_value">{{ data.companyNameCn }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.companyNameEn") }}：
          </div>
          <div class="form_value">{{ data.companyNameEn }}</div>
        </el-col>
      </template>
      <!-- PUBLIC -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          <span v-if="isPerson"
            >{{ $t("hzmbChange.label.personMacauMobile") }}：</span
          >
          <span v-if="isCompany"
            >{{ $t("hzmbChange.label.company_applicantMobile") }}：</span
          >
        </div>
        <div class="form_value">
          {{ data.applicantMobile ? "+853" : "" }} {{ data.applicantMobile }}
        </div>
      </el-col>
      <el-col :span="24">
        <div class="form_label">
          <span v-if="isPerson"
            >{{
              $t("hzmbChange.label.personMacauAddress")
            }}：</span
          >
          <span v-if="isCompany"
            >{{ $t("hzmbChange.label.company_macauAddress") }}：</span
          >
        </div>
        <div class="form_value">
          {{ data.macauAddress.textCn || data.macauAddress.textPt }}
        </div>
      </el-col>
      <el-col v-if="!isGHCompany" :xs="24" :sm="12">
        <div class="form_label">
          <span v-if="isPerson"
            >{{ $t("hzmbChange.label.personMainlandPhone") }}：</span
          >
          <span v-if="isCompany"
            >{{ $t("hzmbChange.label.company_mainlandPhone") }}：</span
          >
        </div>
        <div class="form_value">
          {{ data.mainlandPhone ? "+86" : "" }} {{ data.mainlandPhone }}
        </div>
      </el-col>
      <el-col v-if="!isGHCompany" :xs="24" :sm="12">
        <div class="form_label">
          <span v-if="isPerson"
            >{{ $t("hzmbChange.label.personMainlandEmail") }}：</span
          >
          <span v-if="isCompany"
            >{{ $t("hzmbChange.label.company_mainlandEmail") }}：</span
          >
        </div>
        <div class="form_value">{{ data.mainlandEmail }}</div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          <span v-if="isPerson"
            >{{ $t("hzmbChange.label.personHkPhone") }}：</span
          >
          <span v-if="isCompany"
            >{{ $t("hzmbChange.label.company_hkPhone") }}：</span
          >
        </div>
        <div class="form_value">
          {{ data.hkPhone ? "+852" : "" }} {{ data.hkPhone }}
        </div>
      </el-col>
      <el-col v-if="!isGHCompany" :xs="24" :sm="24">
        <div class="form_label">
          <span v-if="isPerson"
            >{{ $t("hzmbChange.label.personHkAddress") }}：</span
          >
          <span v-if="isCompany"
            >{{ $t("hzmbChange.label.company_hkAddress") }}：</span
          >
        </div>
        <div class="form_value">{{ data.hkAddress }}</div>
      </el-col>
    </el-row>
  </CheckFormBox>
</template>

<script>
import VssViewAPI from "@/api/VssViewAPI";
import CheckFormBox from "@/view/DataRegistration/Check/components/CheckFormBox.vue";
export default {
  props: ["data", "caseNo", "isGHCompany"],
  components: { CheckFormBox },
  data() {
    return {
      idType: [],
      companyType: [
        {
          code: "CO",
          label: "message.companyTypeCO",
        },
        {
          code: "EM",
          label: "message.companyTypeEM",
        },
        {
          code: "SO",
          label: "message.companyTypeSO",
        },
      ],
    };
  },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    isPerson() {
      return this.serviceType === "HZMB_CHANGE_PERSON";
    },
    isCompany() {
      return ["HZMB_CHANGE_COMP", "HZMB_GH_CHANGE_COMP"].includes(
        this.serviceType
      );
    },
  },
  async created() {
    if (this.isPerson) {
      try {
        this.idType = await VssViewAPI.getIdentityTypes();
      } catch (error) {
        this.$error(error);
      }
    }
  },
};
</script>
